import { render, staticRenderFns } from "./deliveryperson.vue?vue&type=template&id=142dc6ea&"
import script from "./deliveryperson.vue?vue&type=script&lang=js&"
export * from "./deliveryperson.vue?vue&type=script&lang=js&"
import style0 from "./deliveryperson.vue?vue&type=style&index=0&id=142dc6ea&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142dc6ea')) {
      api.createRecord('142dc6ea', component.options)
    } else {
      api.reload('142dc6ea', component.options)
    }
    module.hot.accept("./deliveryperson.vue?vue&type=template&id=142dc6ea&", function () {
      api.rerender('142dc6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/deliveryperson.vue"
export default component.exports